var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import * as queryString from 'querystring';
import { OidcService } from './service/OidcService';
import LocalStorage from './storage';
// Wrap everything inside ReactNativeKeycloakProvider
var ReactKeycloakAdapter = /** @class */ (function () {
    function ReactKeycloakAdapter(client) {
        this.client = client;
        this.callbackStorage = new LocalStorage();
        this.oidcService = new OidcService();
    }
    ReactKeycloakAdapter.prototype.login = function (options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var reason, loginUrl, loginUrlParams, params, response, oauthResponse, error_1, axiosError, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!options ||
                            (options.action !== 'refresh_token' && !options.password) ||
                            (!options.username && !(options.policyNumber && options.memberId))) {
                            reason = 'username/password or policyNum/memberId/password is required for login!';
                            console.log(reason);
                            return [2 /*return*/, Promise.reject(reason)];
                        }
                        loginUrl = this.client.createLoginUrl(options);
                        loginUrlParams = queryString.parse(loginUrl);
                        params = new URLSearchParams();
                        params.append('client_id', (_a = this.client.clientId) !== null && _a !== void 0 ? _a : '');
                        params.append('scope', 'openid');
                        params.append('device', options === null || options === void 0 ? void 0 : options.device);
                        params.append('deviceVersion', options === null || options === void 0 ? void 0 : options.deviceVersion);
                        params.append('deviceId', options === null || options === void 0 ? void 0 : options.deviceId);
                        params.append('loginMethod', options === null || options === void 0 ? void 0 : options.loginMethod);
                        params.append('loginPlatform', options === null || options === void 0 ? void 0 : options.loginPlatform);
                        if (options.action === 'refresh_token') {
                            params.append('grant_type', 'refresh_token');
                            params.append('refresh_token', options === null || options === void 0 ? void 0 : options.refreshToken);
                        }
                        else {
                            params.append('grant_type', 'password');
                            params.append('password', options === null || options === void 0 ? void 0 : options.password);
                        }
                        if (options.username) {
                            params.append('username', options === null || options === void 0 ? void 0 : options.username);
                        }
                        else {
                            params.append('policyNumber', options === null || options === void 0 ? void 0 : options.policyNumber);
                            params.append('memberId', options === null || options === void 0 ? void 0 : options.memberId);
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.oidcService.updateToken(params, this.client.realm, this.client.authServerUrl)];
                    case 2:
                        response = _c.sent();
                        if (!response) {
                            return [2 /*return*/, Promise.reject('Invalid Oauth Response')];
                        }
                        oauthResponse = this.prepareOAuthResponse(response, loginUrlParams);
                        return [2 /*return*/, this.client.processCallback(oauthResponse)];
                    case 3:
                        error_1 = _c.sent();
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        if (axios.isAxiosError(error_1)) {
                            axiosError = error_1;
                            response = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.data;
                            if (response) {
                                return [2 /*return*/, this.client.processCallback(response)];
                            }
                        }
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReactKeycloakAdapter.prototype.prepareOAuthResponse = function (oauthParsed, loginUrlParams) {
        var oauthState = this.callbackStorage.get(loginUrlParams.state);
        if (oauthState) {
            return __assign(__assign({}, oauthParsed), { valid: true, redirectUri: oauthState.redirectUri, storedNonce: oauthState.nonce, prompt: oauthState.prompt, pkceCodeVerifier: oauthState.pkceCodeVerifier });
        }
        return oauthParsed;
    };
    ReactKeycloakAdapter.prototype.logout = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window !== 'object') {
                            // does not appear to be a browser environment
                            throw new Error('This code is only meant to run in a browser environment');
                        }
                        return [4 /*yield*/, this.revokeToken()];
                    case 1:
                        _a.sent();
                        window.location.replace(this.client.createLogoutUrl(options));
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    ReactKeycloakAdapter.prototype.revokeToken = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var params, reason, error_2, axiosError, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (typeof window !== 'object') {
                            // does not appear to be a browser environment
                            throw new Error('This code is only meant to run in a browser environment');
                        }
                        params = new URLSearchParams();
                        if (this.client.clientId && this.client.refreshToken) {
                            params.append('client_id', this.client.clientId);
                            params.append('token', this.client.refreshToken);
                            params.append('token_type_hint', 'refresh_token');
                        }
                        else {
                            reason = 'There are no clientId or refreshToken';
                            return [2 /*return*/, Promise.reject(reason)];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.oidcService.revokeToken(params, this.client.realm, this.client.authServerUrl)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, Promise.resolve()];
                    case 3:
                        error_2 = _b.sent();
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        if (axios.isAxiosError(error_2)) {
                            axiosError = error_2;
                            response = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
                            if (response) {
                                return [2 /*return*/, this.client.processCallback(response)];
                            }
                        }
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReactKeycloakAdapter.prototype.register = function (options) {
        window.location.replace(this.client.createRegisterUrl(options));
        return Promise.resolve();
    };
    ReactKeycloakAdapter.prototype.redirectUri = function (options, encodeHash) {
        if (options && options.redirectUri) {
            return options.redirectUri;
        }
        else if (this.client.redirectUri) {
            return this.client.redirectUri;
        }
        else {
            return window.location.href;
        }
    };
    ReactKeycloakAdapter.prototype.accountManagement = function () {
        var accountUrl = this.client.createAccountUrl();
        if (typeof accountUrl !== 'undefined') {
            window.location.href = accountUrl;
        }
        else {
            throw new Error('Not supported by the OIDC server');
        }
        return Promise.resolve();
    };
    ReactKeycloakAdapter.prototype.createCallbackStorage = function () {
        this.callbackStorage = new LocalStorage();
        return this.callbackStorage;
    };
    ReactKeycloakAdapter.prototype.fetchKeycloakConfigJSON = function (configUrl) {
        return this.oidcService.fetchKeycloakConfigJSON(configUrl);
    };
    ReactKeycloakAdapter.prototype.fetchOIDCProviderConfigJSON = function (configUrl) {
        return this.oidcService.fetchOIDCProviderConfigJSON(configUrl);
    };
    ReactKeycloakAdapter.prototype.fetchTokens = function (tokenUrl, params) {
        return this.oidcService.refreshTokens(tokenUrl, params);
    };
    ReactKeycloakAdapter.prototype.refreshTokens = function (tokenUrl, params) {
        return this.oidcService.refreshTokens(tokenUrl, params);
    };
    ReactKeycloakAdapter.prototype.fetchUserProfile = function (profileUrl, token) {
        return this.oidcService.fetchUserProfile(profileUrl, token);
    };
    ReactKeycloakAdapter.prototype.fetchUserInfo = function (userInfoUrl, token) {
        return this.oidcService.fetchUserInfo(userInfoUrl, token);
    };
    return ReactKeycloakAdapter;
}());
export default ReactKeycloakAdapter;
//# sourceMappingURL=ReactKeycloakAdapter.js.map